import { render, staticRenderFns } from "./TableTh.vue?vue&type=template&id=02e21a54&scoped=true"
import script from "./TableTh.vue?vue&type=script&lang=js"
export * from "./TableTh.vue?vue&type=script&lang=js"
import style0 from "./TableTh.vue?vue&type=style&index=0&id=02e21a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e21a54",
  null
  
)

export default component.exports